import { Observable } from "rxjs";
import { PlanScheduled } from "../domain/models/scheduler/plan-scheduled.js";
import { PlanScheduledRequest } from "../domain/requests/plans/get-scheduled-plans-request.js";
import { UpdateSchedulerInstanceRequest } from "../domain/requests/Scheduler/update-scheduler-instance-request.js";
import { CreateSchedulerInstanceRequest } from "../domain/requests/Scheduler/create-scheduler-instance.js";
import { ExceptionDates } from "../domain/models/scheduler/exception-dates.js";

export abstract class PlanScheduledRepository {
    abstract getPlanScheduled(request: PlanScheduledRequest): Observable<PlanScheduled[]>;

    abstract updateSchedulerInstance(request: UpdateSchedulerInstanceRequest): Observable<boolean>;

    abstract createSchedulerInstance(request: CreateSchedulerInstanceRequest): Observable<ExceptionDates>;

    abstract removeSchedulerInstance(request: any): Observable<ExceptionDates>;
}